<template>
	<b-modal
		id="tranDetailModal"
		:visible="isOpen"
		@hidden="$emit('close')"
		centered
		hide-header
		hide-footer
		size="md"
		content-class="tdm-content"
	>
		<!-- Header -->
		<div
			class="tdm-header d-flex justify-content-between align-items-center px-4 py-3"
		>
			<h3 class="tdm-title m-0">Transaction Details</h3>
			<img @click="$emit('close')" src="../../assets/xmark.svg" alt="" />
		</div>

		<!-- Body -->
		<div class="tdm-body px-4 pt-3 pb-2">
			<div class="tdm-row d-flex justify-content-between py-2 px-3">
				<span class="tdm-label">List Price</span>
				<span class="tdm-value">₹{{ listPrice }}</span>
			</div>
			<div
				class="tdm-row tdm-row-bg d-flex justify-content-between py-2 rounded-sm px-3 mt-1 mb-1"
			>
				<span class="tdm-label">Discount</span>
				<span class="tdm-value">₹{{ discount }}</span>
			</div>
			<div class="tdm-row d-flex justify-content-between py-2 px-3">
				<span class="tdm-label">Final Price</span>
				<span class="tdm-value">₹{{ finalPrice }}</span>
			</div>
			<div
				class="tdm-row tdm-row-bg d-flex justify-content-between py-2 rounded-sm px-3 mt-1 mb-1"
			>
				<span class="tdm-label">Hire3x Charge</span>
				<span class="tdm-value">{{ hire3xCharge }}%</span>
			</div>
			<div class="tdm-row d-flex justify-content-between py-2 pb-3 px-3">
				<span class="tdm-label">Final Amount Receivable</span>
				<span class="tdm-value">₹{{ finalAmount }}</span>
			</div>
		</div>

		<!-- Marketplace info -->
		<div v-if="transaction.pricingType === 1" class="tdm-info-box d-flex justify-content-center py-3">
			<span
				class="info-icon mr-2 d-flex align-items-center justify-content-center"
				style="width: 16px; height: 16px; border-radius: 50%; background: #8E8E9E; color: white; font-size: 10px; font-weight: bold; font-family: sans-serif;"
			>
				i
			</span>
			<span class="tdm-info-text"
				>Bought from <span class="tdm-marketplace-text">Marketplace</span></span
			>
		</div>

		<!-- Footer -->
		<div class="tdm-footer d-flex justify-content-end px-4 py-3">
			<b-button class="new-addBtn" @click="$emit('close')">
				Okay
			</b-button>
		</div>
	</b-modal>
</template>

<script>
export default {
	name: "TransactionDetailsModal",
	props: {
		transaction: {
			type: Object,
			default: () => ({}),
		},
		isOpen: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		listPrice() {
			return this.transaction?.paymentBreakdown?.listPrice || 0;
		},
		discount() {
			return this.transaction?.paymentBreakdown?.discount || 0;
		},
		finalPrice() {
			return this.transaction?.paymentBreakdown?.amount || 0;
		},
		hire3xCharge() {
			return this.transaction?.paymentBreakdown?.chargesPercentage || 0;
		},
		finalAmount() {
			const fp = Number(this.finalPrice) || 0;
			const hc = Number(this.hire3xCharge) || 0;
			return fp - (fp * hc) / 100;
		},
	},
};
</script>

<style>
/* Applied globally to effect modal content class injected by b-modal */
.tdm-content {
	background: #ffffff;
	border-radius: 12px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
	font-family: "Lato", sans-serif;
	overflow: hidden;
}
#tranDetailModal .modal-body {
	padding: 0;
}
</style>

<style scoped>
.tdm-header {
	border-bottom: 1px solid #eaedf3;
}
.tdm-title {
	font-family: "Lato", sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #000000;
}
.cursor-pointer {
	cursor: pointer;
}
.tdm-label {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	color: #344054;
	font-size: 14px;
}
.tdm-value {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	color: #333333;
	font-size: 14px;
}
.tdm-row-bg {
	background: #fbfbfb;
	border-radius: 6px;
}
.tdm-info-box {
	background: #fffaf9;
	border-top: 1px solid #fdf0ee;
	border-bottom: 1px solid #f2e8e8;
	align-items: center;
	width: 100%;
}
.tdm-info-text {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #202020;
}
.tdm-marketplace-text {
	color: #ba2d2d;
	font-weight: 600;
}
.tdm-okay-btn {
	background: #72738e;
	color: white;
	border: none;
	border-radius: 20px;
	padding: 8px 24px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: background 0.2s ease;
}
.tdm-okay-btn:hover {
	background: #55566a;
}
</style>
